import { createFileRoute } from '@tanstack/react-router'
import { OrgChart } from '@/components/compliance/people/OrgChart'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/org-chart',
)({
  component: () => <OrgChart />,
})
